import React from "react";
import moment from 'moment';
//配置项
let componentName = 'examRecord';

let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = (data) => {
  const {examId,questionId} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "错误答案",
      name: "answer",
      tableItem: {
        width: 200,
      },
    },
    {
      title: "答错人数",
      name: "answerErrorPersonIdCount",
      tableItem: {
        width: 200,
      },
    },
    {
      title: "答错次数",
      name: "answerErrorTimeCount",
      tableItem: {
      },
    },
   
    
  ]
};

const templateConfig = (data) => {
  const {questionId} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        btnAccessCheck:false,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['export'],
          buttons: [
            
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "exportAnswer",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters, examId: data.examId ,questionId:data.questionId}
                }
              }
            },
          ]
        },
       
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['errorQuestionAnalysis'],
        rowOperateView: [
          {
            key: 'errorQuestionAnalysis',//错误人员情况
            custom: true,
            params: {children: '错误人员情况'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/examRecord/errorQuestionInfo/errorQuestionAnalysis/errorQuestionPersonInfoList',
                record:data
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {examId,questionId} = data;
  return {
    list: {
      path: `${componentName}/getErrorQuestionAnswerPage`,
      payload: {
        key: `${componentName}@getErrorQuestionAnswerPage`,
        apiParams: {pageNum: 1, pageSize: 10,examId,questionId}
      }
    },
    exportAnswer: {
      path: `${componentName}/getErrorQuestionAnswerExport`,
      payload: {
        key: `${componentName}@getErrorQuestionAnswerExport`,
        apiParams: {examId,questionId}
      }
    },
  }
};


let reduxTemplateConfig = (args) => {
  const {examId,questionId} = args;
  return {
    apis: apis({examId,questionId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
